export default __webpack_public_path__ + "static/media/happets3.0fcbf082.png";